
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useItemTranslate } from '@/modules/item/system/model/translate';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';

export default defineComponent({
    name: ROUTE_NAME_ITEM.SYSTEM.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions, systemLocaleSupported } = useItemTranslate();

        return { v$, model, fetch, actions, systemLocaleSupported };
    }
});
